var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTickImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9425 1.06754L5.94254 11.0675C5.88449 11.1256 5.81556 11.1717 5.73969 11.2032C5.66381 11.2347 5.58248 11.2508 5.50035 11.2508C5.41821 11.2508 5.33688 11.2347 5.26101 11.2032C5.18514 11.1717 5.11621 11.1256 5.05816 11.0675L0.68316 6.69254C0.565885 6.57526 0.5 6.4162 0.5 6.25035C0.5 6.0845 0.565885 5.92544 0.68316 5.80816C0.800435 5.69088 0.959495 5.625 1.12535 5.625C1.2912 5.625 1.45026 5.69088 1.56753 5.80816L5.50035 9.74175L15.0582 0.18316C15.1754 0.0658843 15.3345 -1.2357e-09 15.5003 0C15.6662 1.2357e-09 15.8253 0.0658843 15.9425 0.18316C16.0598 0.300435 16.1257 0.459495 16.1257 0.625347C16.1257 0.7912 16.0598 0.95026 15.9425 1.06754Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTickImg);
export default __webpack_public_path__ + "static/media/right_tick_img.da72d17f5c994c251d53e39ef349b391.svg";
export { ForwardRef as ReactComponent };